import { jsx as _jsx } from "react/jsx-runtime";
import { useIntl } from 'react-intl';
import { IntlContext } from './intl-context';
export const CombinedProvider = ({ children, language, country, currencySymbol, formatCurrency, formatCurrencyToObject, }) => (_jsx(IntlContext.Provider, { value: {
        language,
        country,
        formatCurrency,
        formatCurrencyToObject,
        currencySymbol,
        ...useIntl(),
    }, children: children }));
//# sourceMappingURL=combined-context-provider.js.map